export const environment = {
  production: true,
  lastCommitHash: 'd095c4a6438d3fbfcaa143cda275f44a4d3226fe',
};
